import { environment } from "src/environments/environment";

export const DEFAULT_AVATAR = 'assets/images/default-avatar.png';
export const SIDEBAR_LOGO = 'assets/images/logotype-white.png';

const version = environment.version.split('+');
export const ADP_VERSION = `${version[0]} (${version[1] ?? ''})`;
